import React from 'react';
import './StrengthMeter.css';
import zxcvbn from 'zxcvbn';

function getNotANSCIIChars(str) {
    let chars = str.split('');
    let unsupportedCharacters = chars.filter(char => char.charCodeAt(0) > 127);
    return unsupportedCharacters;
}

const StrengthMeter = (props) => {
    let password = '';
    if (!props.password) {
        password = '';
    } else {
        password = props.password;
    }

    const testedResult = zxcvbn(password);

    const getProgressBarLabel = (result) => {
        if (result.password === '') {
            return '';
        }
        if (getNotANSCIIChars(result.password).length > 0) {
            let unallowedChars = getNotANSCIIChars(result.password);
            let message = "Ditt lösenord innehåller ogiltiga tecken " + unallowedChars.join(', ')
            return message;
        }

        switch (result.score) {
            case 0:
                return 'Svagt';
            case 1:
                return 'Svagt';
            case 2:
                return 'Ganska bra';
            case 3:
                return 'Bra';
            case 4:
                return 'Starkt';
            default:
                return '';
        }
    }

    const getProgressBarPercent = (result) => {
        if (result.password === '') {
            return 0;
        }
        if (getNotANSCIIChars(result.password).length > 0) {
            return 0;
        }

        switch (result.score) {
            case 0:
                return 25;
            case 1:
                return 25;
            case 2:
                return 50;
            case 3:
                return 75;
            case 4:
                return 100;
            default:
                return 0;
        }
    }

    const getProgressBarWidthStyle = (result) => {
        if (result.password === '') {
            return {width: '0%'};
        }
        if (getNotANSCIIChars(result.password).length > 0) {
            return {width: '100%'};
        }

        switch (result.score) {
            case 0:
                return {width: '25%'};
            case 1:
                return {width: '25%'};
            case 2:
                return {width: '50%'};
            case 3:
                return {width: '75%'};
            case 4:
                return {width: '100%'};
            default:
                return {width: '0%'};
        }
    }

    const getProgressBarColorStyle = (result) => {
        if (result.password === '') {
            return '';
        }
        if (getNotANSCIIChars(result.password).length > 0) {
            return 'bg-danger';
        }

        switch (result.score) {
            case 0:
                return 'bg-danger';
            case 1:
                return 'bg-danger';
            case 2:
                return 'bg-warning';
            case 3:
                return 'bg-info';
            case 4:
                return 'bg-success';
            default:
                return '';
        }
    }

    return (
        <div className="progress password-strength-meter">
            <div
                className={`password-strength-meter progress-bar ${getProgressBarColorStyle(testedResult)} width:${getProgressBarPercent(testedResult)}%`}
                role="progressbar"
                style={getProgressBarWidthStyle(testedResult)}
                aria-valuenow={getProgressBarPercent(testedResult)}
                aria-valuemin="0"
                aria-valuemax="100"
            >
                <span className="paragraph-regular-14">{getProgressBarLabel(testedResult)}</span>
            </div>
        </div>
    );
}

export default StrengthMeter;